import { all, takeEvery, put, call } from 'redux-saga/effects'
import {
  getTransportistas,
  insertTransportista,
  updateTransportista,
  deleteTransportista,
  getTransportista,
  getTransportistasVacaciones,
  getTransportistasComentarios,
  getTransportistasVisibles,
  insertVacacionesTransportista,
  deleteVacacionesTransportista,
  deleteComentarioTransportista,
  insertComentarioTransportista,
  deleteVisibleTransportista,
  insertVisibleTransportista,
  cambiarVisibleTodosTransportista,
} from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_TRANSPORTISTA_ID(payload) {
  try {
    const transportista = yield call(getTransportista, payload.id)
    if (transportista.ok) {
      yield put({
        type: actions.TRANSPORTISTA_BY_ID_LOAD_SUCCEEDED,
        payload: transportista.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar transportista')
      yield put({
        type: actions.TRANSPORTISTA_BY_ID_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.TRANSPORTISTA_BY_ID_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_TRANSPORTISTAS() {
  try {
    const transportistas = yield call(getTransportistas)
    if (transportistas.ok) {
      yield put({
        type: actions.TRANSPORTISTAS_LOAD_SUCCEEDED,
        payload: transportistas.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar transportistas')
      yield put({
        type: actions.TRANSPORTISTAS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.TRANSPORTISTAS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_TRANSPORTISTAS_VACACIONES() {
  try {
    const transportistas = yield call(getTransportistasVacaciones)
    if (transportistas.ok) {
      yield put({
        type: actions.TRANSPORTISTAS_VACACIONES_LOAD_SUCCEEDED,
        payload: transportistas.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar transportistas')
      yield put({
        type: actions.TRANSPORTISTAS_VACACIONES_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.TRANSPORTISTAS_VACACIONES_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_TRANSPORTISTAS_COMENTARIOS(action) {
  try {
    const transportistas = yield call(getTransportistasComentarios, action.payload)
    if (transportistas.ok) {
      yield put({
        type: actions.TRANSPORTISTAS_COMENTARIOS_LOAD_SUCCEEDED,
        payload: transportistas.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar comentarios')
      yield put({
        type: actions.TRANSPORTISTAS_COMENTARIOS_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.TRANSPORTISTAS_COMENTARIOS_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_TRANSPORTISTA(action) {
  try {
    const transportista = yield call(insertTransportista, action.payload)
    if (transportista.ok) {
      putMessage(messageType.SUCCESS, 'Transportista creado correctamente')
      yield put({
        type: actions.TRANSPORTISTA_INSERT_SUCCEEDED,
        payload: transportista.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Transportista página')
      yield put({
        type: actions.TRANSPORTISTA_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Transportista página')
    yield all([
      put({
        type: actions.TRANSPORTISTA_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* UPDATE_TRANSPORTISTA(action) {
  try {
    const transportista = yield call(updateTransportista, action.payload)
    if (transportista.ok) {
      putMessage(messageType.SUCCESS, 'Transportista modificado correctamente')
      yield put({
        type: actions.TRANSPORTISTA_UPDATE_SUCCEEDED,
        payload: transportista.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al modificar Transportista')
      yield put({
        type: actions.TRANSPORTISTA_UPDATE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al modificar Transportista')
    yield all([
      put({
        type: actions.TRANSPORTISTA_UPDATE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_TRANSPORTISTA(id) {
  try {
    const transportista = yield call(deleteTransportista, id)
    if (transportista.ok) {
      putMessage(messageType.SUCCESS, 'Transportista eliminado correctamente')
      yield put({
        type: actions.TRANSPORTISTA_DELETE_SUCCEEDED,
        payload: id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Transportista')
      yield put({
        type: actions.TRANSPORTISTA_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Transportista')
    yield all([
      put({
        type: actions.TRANSPORTISTA_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_VACACIONES_TRANSPORTISTA(action) {
  try {
    const transportista = yield call(insertVacacionesTransportista, action.payload)
    if (transportista.ok) {
      putMessage(messageType.SUCCESS, 'Vacaciones creadas correctamente')
      yield put({
        type: actions.TRANSPORTISTA_VACACIONES_INSERT_SUCCEEDED,
        payload: transportista.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Vacaciones')
      yield put({
        type: actions.TRANSPORTISTA_VACACIONES_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Vacaciones')
    yield all([
      put({
        type: actions.TRANSPORTISTA_VACACIONES_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_VACACIONES_TRANSPORTISTA(payload) {
  try {
    const transportista = yield call(deleteVacacionesTransportista, payload.id)
    if (transportista.ok) {
      putMessage(messageType.SUCCESS, 'Vacaciones eliminadas correctamente')
      yield put({
        type: actions.TRANSPORTISTA_VACACIONES_DELETE_SUCCEEDED,
        id: payload.id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Vacaciones')
      yield put({
        type: actions.TRANSPORTISTA_VACACIONES_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Vacaciones')
    yield all([
      put({
        type: actions.TRANSPORTISTA_VACACIONES_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_COMENTARIOS_TRANSPORTISTA(action) {
  try {
    const transportista = yield call(insertComentarioTransportista, action.payload)
    if (transportista.ok) {
      putMessage(messageType.SUCCESS, 'Comentario creado correctamente')
      yield put({
        type: actions.TRANSPORTISTA_COMENTARIOS_INSERT_SUCCEEDED,
        payload: transportista.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear Comentario')
      yield put({
        type: actions.TRANSPORTISTA_COMENTARIOS_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear Comentario')
    yield all([
      put({
        type: actions.TRANSPORTISTA_COMENTARIOS_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_COMENTARIOS_TRANSPORTISTA(payload) {
  try {
    const transportista = yield call(deleteComentarioTransportista, payload.id)
    if (transportista.ok) {
      putMessage(messageType.SUCCESS, 'Comentarios eliminadas correctamente')
      yield put({
        type: actions.TRANSPORTISTA_COMENTARIOS_DELETE_SUCCEEDED,
        payload: payload.id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar Comentarios')
      yield put({
        type: actions.TRANSPORTISTA_COMENTARIOS_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar Comentarios')
    yield all([
      put({
        type: actions.TRANSPORTISTA_COMENTARIOS_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_VISIBLES_COMENTARIOS(action) {
  try {
    const transportistas = yield call(getTransportistasVisibles, action.payload)
    if (transportistas.ok) {
      yield put({
        type: actions.TRANSPORTISTAS_VISIBLES_LOAD_SUCCEEDED,
        payload: transportistas.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar visibles')
      yield put({
        type: actions.TRANSPORTISTAS_VISIBLES_LOAD_FAILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.TRANSPORTISTAS_VISIBLES_LOAD_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* INSERT_VISIBLES_TRANSPORTISTA(action) {
  try {
    const transportista = yield call(insertVisibleTransportista, action.payload)
    if (transportista.ok) {
      yield put({
        type: actions.TRANSPORTISTA_VISIBLES_INSERT_SUCCEEDED,
        payload: transportista.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear visibles')
      yield put({
        type: actions.TRANSPORTISTA_VISIBLES_INSERT_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear visibles')
    yield all([
      put({
        type: actions.TRANSPORTISTA_VISIBLES_INSERT_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* DELETE_VISIBLES_TRANSPORTISTA(payload) {
  try {
    const transportista = yield call(deleteVisibleTransportista, payload.id)
    if (transportista.ok) {
      yield put({
        type: actions.TRANSPORTISTA_VISIBLES_DELETE_SUCCEEDED,
        payload: payload.id,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al eliminar visibles')
      yield put({
        type: actions.TRANSPORTISTA_VISIBLES_DELETE_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al eliminar visibles')
    yield all([
      put({
        type: actions.TRANSPORTISTA_VISIBLES_DELETE_FAILED,
        error: e.message,
      }),
    ])
  }
}

export function* TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS(action) {
  try {
    const transportista = yield call(cambiarVisibleTodosTransportista, action.payload)
    if (transportista.ok) {
      yield put({
        type: actions.TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_SUCCEEDED,
        payload: transportista.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al crear visibles')
      yield put({
        type: actions.TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_FAILED,
      })
    }
  } catch (e) {
    putMessage(messageType.ERROR, 'Error al crear visibles')
    yield all([
      put({
        type: actions.TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_FAILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.TRANSPORTISTAS_LOAD_REQUESTED, GET_TRANSPORTISTAS),
    takeEvery(actions.TRANSPORTISTA_BY_ID_LOAD_REQUESTED, GET_TRANSPORTISTA_ID),
    takeEvery(actions.TRANSPORTISTA_INSERT_REQUESTED, INSERT_TRANSPORTISTA),
    takeEvery(actions.TRANSPORTISTA_UPDATE_REQUESTED, UPDATE_TRANSPORTISTA),
    takeEvery(actions.TRANSPORTISTA_DELETE_REQUESTED, DELETE_TRANSPORTISTA),
    takeEvery(actions.TRANSPORTISTAS_VACACIONES_LOAD_REQUESTED, GET_TRANSPORTISTAS_VACACIONES),
    takeEvery(actions.TRANSPORTISTAS_COMENTARIOS_LOAD_REQUESTED, GET_TRANSPORTISTAS_COMENTARIOS),
    takeEvery(actions.TRANSPORTISTA_VACACIONES_INSERT_REQUESTED, INSERT_VACACIONES_TRANSPORTISTA),
    takeEvery(actions.TRANSPORTISTA_VACACIONES_DELETE_REQUESTED, DELETE_VACACIONES_TRANSPORTISTA),
    takeEvery(actions.TRANSPORTISTA_COMENTARIOS_INSERT_REQUESTED, INSERT_COMENTARIOS_TRANSPORTISTA),
    takeEvery(actions.TRANSPORTISTA_COMENTARIOS_DELETE_REQUESTED, DELETE_COMENTARIOS_TRANSPORTISTA),
    takeEvery(actions.TRANSPORTISTAS_VISIBLES_LOAD_REQUESTED, GET_VISIBLES_COMENTARIOS),
    takeEvery(actions.TRANSPORTISTA_VISIBLES_INSERT_REQUESTED, INSERT_VISIBLES_TRANSPORTISTA),
    takeEvery(actions.TRANSPORTISTA_VISIBLES_DELETE_REQUESTED, DELETE_VISIBLES_TRANSPORTISTA),
    takeEvery(
      actions.TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS_REQUESTED,
      TRANSPORTISTA_CAMBIAR_VISIBLES_TODOS,
    ),
  ])
}
